import React, { useEffect } from 'react';
import ProductCard from '../components/ProductCard';
import Loader from '../components/Loader';
import { useNavigate } from 'react-router-dom';
import { Pagination, Stack } from '@mui/material';
import useProductListing from '../hooks/useProductListing';

// 277 products in the live catalogue. Previously this fetched all 2,279 and
// filtered down to these in the browser.
const CATEGORY_SLUGS = ['skin-care'];

function BeautySalfCare({ isAuthenticated, onAddToCart }) {
  const navigate = useNavigate();

  const {
    products,
    loading,
    error,
    missingCategories,
    currentPage,
    totalPages,
    setPage,
  } = useProductListing({ categorySlugs: CATEGORY_SLUGS, perPage: 30 });

  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem('user_data')) || {};
    if (userData.isSuperAdmin) navigate('/dashboard');
  }, [navigate]);

  if (loading) return <Loader />;

  return (
    <div className="content-wrapper">
      <section className="beauty">
        <h3 style={{ fontSize: '22px', textAlign: 'center', padding: '20px 0' }}>
          {'beauty and self care'.toLocaleUpperCase()}
        </h3>
        <section className="char-products-section" style={{ margin: '0 0 20px' }}>
          <div className="small-container d-grid">
            {products.length > 0 ? (
              products.map(item => (
                <ProductCard
                  isAuthenticated={isAuthenticated}
                  onAddToCart={onAddToCart}
                  key={item.id}
                  product={item}
                />
              ))
            ) : (
              <p>
                {error
                  ? error
                  : missingCategories.length > 0
                    ? 'This section is not set up yet. Please check back soon.'
                    : 'No products found!'}
              </p>
            )}
          </div>
          {totalPages > 1 && (
            <Stack spacing={2} style={{ margin: '5% auto 0', display: 'flex', alignItems: 'center' }}>
              <Pagination
                count={totalPages}
                page={currentPage}
                onChange={(event, value) => setPage(value)}
                color="primary"
              />
            </Stack>
          )}
        </section>
      </section>
    </div>
  );
}

export default BeautySalfCare;
